/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedNullSearchRelatedItems_user = {
    readonly " $fragmentRefs": FragmentRefs<"useMeasurementUnit_user" | "SbSharedNullSearchRelatedItemsFollow_user">;
    readonly " $refType": "SbSharedNullSearchRelatedItems_user";
};
export type SbSharedNullSearchRelatedItems_user$data = SbSharedNullSearchRelatedItems_user;
export type SbSharedNullSearchRelatedItems_user$key = {
    readonly " $data"?: SbSharedNullSearchRelatedItems_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedNullSearchRelatedItems_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedNullSearchRelatedItems_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useMeasurementUnit_user",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "profile",
          "storageKey": null,
          "args": null,
          "concreteType": "Profile",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "measurementUnit",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedNullSearchRelatedItemsFollow_user",
      "args": null
    }
  ]
};
(node as any).hash = 'de5024cff24e25e65909b4f3f15bcdb4';
export default node;
